// Utilidades de los componentes del Brain que **no** son componentes.
//
// Van aparte porque exportar una funcion junto a un componente rompe el fast
// refresh de Vite, y ademas coincide con la regla de un componente por fichero.

import type { Agent, Entity, PropSections } from './types'

/**
 * El color del avatar de un agente. Sale de su nombre, asi que el mismo agente
 * se ve siempre igual: es identidad, no estado ni decoracion. Un token no
 * sirve -hacen falta varios colores distinguibles entre si- y por eso es la
 * misma excepcion que la paleta de las etiquetas.
 *
 * **El texto viene con el fondo, y no es un detalle.** Los tres avatares que
 * usan esto se escribian su color de texto por su cuenta, y dos de los tres
 * ponian `text-primary-foreground`, que en modo oscuro es texto OSCURO: es el
 * color que va sobre `bg-primary`, no sobre un violeta. Sobre estos siete
 * tonos medios el texto que se lee es el blanco. El fondo y su texto son una
 * sola decision, asi que se toman en un solo sitio.
 */
/* eslint-disable no-restricted-syntax -- colores de identidad: siete tonos distinguibles, derivados del nombre */
const AVATAR_COLORS = [
  'bg-violet-500 text-white', 'bg-emerald-500 text-white', 'bg-amber-500 text-white',
  'bg-sky-500 text-white', 'bg-rose-500 text-white', 'bg-indigo-500 text-white',
  'bg-teal-500 text-white',
]
/* eslint-enable no-restricted-syntax */

/** Stable colour from the name: same agent, same colour, always.
 *
 * The prototype had `color` and `emoji` on every agent because its agents were
 * made up. The API has neither, so the avatar is the initial over a colour
 * derived from the name: decoration, never a fact nobody stated.
 */
export function agentColor(name: string): string {
  let sum = 0
  for (const c of name) sum = (sum + c.charCodeAt(0)) % 997
  return AVATAR_COLORS[sum % AVATAR_COLORS.length]
}

export function agentInitial(a: Agent): string {
  return (a.display_name || a.name || '?').trim().slice(0, 1).toUpperCase()
}


export function autoDetails(e: Entity): PropSections | null {
  if (e.details && e.details.length > 0) return e.details
  const rows: { label: string; value: string; mono?: boolean }[] = []
  if (e.type === 'agent') {
    rows.push({ label: 'Nombre interno', value: e.name.toLowerCase().replace(/\s+/g, '_'), mono: true })
    if (e.subline) rows.push({ label: 'Descripción', value: e.subline })
    if (e.meta) rows.push({ label: 'Herramientas', value: e.meta })
    rows.push({ label: 'Estado', value: e.status === 'disabled' ? 'Desactivado' : 'Habilitado' })
    return [{ rows }]
  }
  if (e.type === 'tool') {
    rows.push({ label: 'Tipo', value: e.toolType === 'mcp' ? 'MCP' : e.toolType === 'function' ? 'Function' : 'Webhook / HTTP Request' })
    if (e.method) rows.push({ label: 'Método', value: e.method, mono: true })
    if (e.subline) rows.push({ label: 'Descripción', value: e.subline })
    if (e.status) rows.push({ label: 'Estado', value: e.status === 'assigned' ? 'Asignada' : e.status === 'disabled' ? 'Desactivada' : 'Habilitada' })
    return [{ rows }]
  }
  if (e.type === 'secret') {
    if (e.subline) rows.push({ label: 'Uso', value: e.subline })
    rows.push({ label: 'Valor', value: 'Oculto · cifrado, no se vuelve a mostrar' })
    return [{ rows }]
  }
  return null
}
